export const categories = [
  { id: 'recent', name: '热门新番', slug: 'recent', icon: 'ri-fire-line' },
  { id: 'japanese', name: '日漫精选', slug: 'japanese', icon: 'ri-sun-line' },
  { id: 'chinese', name: '国漫专区', slug: 'chinese', icon: 'ri-china-railway-line' },
  { id: 'classic', name: '经典老番', slug: 'classic', icon: 'ri-time-line' },
  { id: 'movie', name: '剧场版', slug: 'movie', icon: 'ri-film-line' },
  { id: 'ova', name: 'OVA/特别篇', slug: 'ova', icon: 'ri-star-line' },
];

export const animeList = [
  {
    id: '1',
    title: '咒术回战 第三季',
    cover: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20poster%20style%2C%20dark%20atmospheric%20illustration%20with%20warrior%20character%20casting%20spells%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20dark%20tones%2C%20clean%20composition%20on%20simple%20dark%20background%2C%20anime%20art%20style&width=600&height=840&seq=anime-cover-01&orientation=portrait',
    category: 'recent',
    rating: 9.7,
    episodes: '更新至第8话',
    status: '连载中',
    description: '虎杖悠仁与伙伴们面对更强大的诅咒，咒术高专与诅咒之王的最终对决即将展开。全新篇章带来更激烈的战斗与更深刻的羁绊。',
    updateInfo: '每周日 01:00 更新',
    year: 2025,
    tags: ['热血', '战斗', '奇幻', '暗黑'],
    views: 1280000,
    likes: 96000,
  },
  {
    id: '2',
    title: '鬼灭之刃 柱训练篇',
    cover: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%20style%2C%20swordsman%20character%20with%20flame%20breathing%20technique%2C%20traditional%20Japanese%20aesthetic%2C%20warm%20amber%20and%20crimson%20tones%2C%20clean%20composition%20on%20dark%20background%2C%20anime%20illustration&width=600&height=840&seq=anime-cover-02&orientation=portrait',
    category: 'recent',
    rating: 9.8,
    episodes: '全8话',
    status: '已完结',
    description: '炭治郎与伙伴们在柱的训练下不断成长，为最终决战做准备。每一位柱都展现出惊人的实力与独特的训练方式。',
    updateInfo: '已完结',
    year: 2024,
    tags: ['热血', '战斗', '历史', '感人'],
    views: 2560000,
    likes: 188000,
  },
  {
    id: '3',
    title: '间谍过家家 第二季',
    cover: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%20style%2C%20family%20of%20three%20characters%20in%20stylish%20outfits%2C%20warm%20and%20playful%20mood%2C%20soft%20pastel%20warm%20tones%2C%20clean%20composition%20on%20light%20background%2C%20anime%20art&width=600&height=840&seq=anime-cover-03&orientation=portrait',
    category: 'recent',
    rating: 9.5,
    episodes: '更新至第18话',
    status: '连载中',
    description: '福杰一家的日常依旧充满欢笑与危机，劳埃德的新任务、约尔的秘密行动、阿尼亚的校园生活交织成一幕幕温馨又有趣的故事。',
    updateInfo: '每周六 23:00 更新',
    year: 2025,
    tags: ['搞笑', '日常', '家庭', '谍战'],
    views: 1890000,
    likes: 142000,
  },
  {
    id: '4',
    title: '葬送的芙莉莲',
    cover: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20poster%20style%2C%20elf%20mage%20character%20in%20flowing%20white%20robe%2C%20nostalgic%20and%20melancholic%20mood%2C%20soft%20warm%20golden%20light%2C%20clean%20composition%20on%20simple%20background%2C%20anime%20illustration&width=600&height=840&seq=anime-cover-04&orientation=portrait',
    category: 'japanese',
    rating: 9.9,
    episodes: '全28话',
    status: '已完结',
    description: '打倒魔王后的漫长岁月里，精灵魔法使芙莉莲重新踏上旅途，在与新伙伴的冒险中重新理解生命与情感的意义。',
    updateInfo: '已完结',
    year: 2024,
    tags: ['治愈', '冒险', '奇幻', '哲学'],
    views: 3200000,
    likes: 256000,
  },
  {
    id: '5',
    title: '一人之下 第五季',
    cover: 'https://readdy.ai/api/search-image?query=The%20Outcast%20Chinese%20anime%20poster%20style%2C%20martial%20arts%20character%20with%20supernatural%20energy%2C%20Chinese%20ink%20painting%20aesthetic%2C%20warm%20earth%20tones%2C%20clean%20composition%20on%20dark%20background%2C%20donghua%20art&width=600&height=840&seq=anime-cover-05&orientation=portrait',
    category: 'chinese',
    rating: 9.3,
    episodes: '更新至第15话',
    status: '连载中',
    description: '张楚岚与冯宝宝的异人世界冒险继续，罗天大醮之后更大的阴谋浮出水面，甲申之乱的真相逐渐揭开。',
    updateInfo: '每周五 12:00 更新',
    year: 2025,
    tags: ['热血', '奇幻', '国漫', '战斗'],
    views: 950000,
    likes: 78000,
  },
  {
    id: '6',
    title: '进击的巨人 最终季',
    cover: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20anime%20poster%20style%2C%20soldier%20character%20with%20determination%2C%20apocalyptic%20and%20epic%20mood%2C%20dark%20dramatic%20tones%2C%20clean%20composition%20on%20dark%20background%2C%20anime%20illustration&width=600&height=840&seq=anime-cover-06&orientation=portrait',
    category: 'classic',
    rating: 9.6,
    episodes: '全16话',
    status: '已完结',
    description: '艾伦发动地鸣，世界陷入前所未有的危机。昔日战友分道扬镳，在毁灭与拯救之间做出最后的抉择，为这部史诗画上句号。',
    updateInfo: '已完结',
    year: 2023,
    tags: ['热血', '战斗', '奇幻', '暗黑'],
    views: 5400000,
    likes: 420000,
  },
  {
    id: '7',
    title: '铃芽之旅',
    cover: 'https://readdy.ai/api/search-image?query=Suzume%20anime%20movie%20poster%20style%2C%20young%20girl%20and%20mysterious%20chair%20traveling%2C%20beautiful%20sky%20and%20nature%20background%2C%20warm%20sunset%20tones%2C%20clean%20composition%2C%20anime%20art&width=600&height=840&seq=anime-cover-07&orientation=portrait',
    category: 'movie',
    rating: 9.4,
    episodes: '全1话',
    status: '已完结',
    description: '17岁少女铃芽遇见了寻找门的青年，两人一同踏上关闭灾祸之门的旅途。在美丽又震撼的冒险中，铃芽逐渐解开内心的伤痛。',
    updateInfo: '已完结',
    year: 2023,
    tags: ['奇幻', '冒险', '治愈', '爱情'],
    views: 2100000,
    likes: 168000,
  },
  {
    id: '8',
    title: '时光代理人 第二季',
    cover: 'https://readdy.ai/api/search-image?query=Link%20Click%20Chinese%20anime%20poster%20style%2C%20two%20young%20men%20with%20mysterious%20abilities%2C%20modern%20urban%20aesthetic%2C%20warm%20amber%20and%20cool%20tones%20contrast%2C%20clean%20composition%2C%20donghua%20art&width=600&height=840&seq=anime-cover-08&orientation=portrait',
    category: 'chinese',
    rating: 9.5,
    episodes: '全12话',
    status: '已完结',
    description: '程小时与陆光继续通过照片穿越时空，每一次的任务都隐藏着意想不到的真相，而更大的阴谋正悄然逼近。',
    updateInfo: '已完结',
    year: 2024,
    tags: ['悬疑', '奇幻', '国漫', '剧情'],
    views: 860000,
    likes: 72000,
  },
  {
    id: '9',
    title: '排球少年!! 垃圾场的决战',
    cover: 'https://readdy.ai/api/search-image?query=Haikyuu%20anime%20movie%20poster%20style%2C%20volleyball%20players%20in%20intense%20match%20action%2C%20energetic%20and%20passionate%20mood%2C%20warm%20orange%20sports%20tones%2C%20clean%20composition%2C%20anime%20art&width=600&height=840&seq=anime-cover-09&orientation=portrait',
    category: 'movie',
    rating: 9.6,
    episodes: '全1话',
    status: '已完结',
    description: '乌野高中与音驹高中之间命运的对决，两只乌鸦在"垃圾场"展开激烈战斗。这是排球少年们最燃最感动的一战。',
    updateInfo: '已完结',
    year: 2024,
    tags: ['热血', '运动', '青春', '友情'],
    views: 1650000,
    likes: 132000,
  },
  {
    id: '10',
    title: '夏日重现',
    cover: 'https://readdy.ai/api/search-image?query=Summer%20Time%20Rendering%20anime%20poster%20style%2C%20characters%20on%20island%20with%20mysterious%20shadow%2C%20suspenseful%20and%20summer%20atmosphere%2C%20warm%20golden%20sunlight%20with%20dark%20contrast%2C%20clean%20composition%2C%20anime%20art&width=600&height=840&seq=anime-cover-10&orientation=portrait',
    category: 'classic',
    rating: 9.3,
    episodes: '全25话',
    status: '已完结',
    description: '网代慎平回到故乡日都岛参加青梅竹马的葬礼，却发现岛上隐藏着不为人知的秘密，一场与时间赛跑的悬疑故事就此展开。',
    updateInfo: '已完结',
    year: 2022,
    tags: ['悬疑', '奇幻', '推理', '剧情'],
    views: 1450000,
    likes: 115000,
  },
  {
    id: '11',
    title: '伍六七之暗影宿命',
    cover: 'https://readdy.ai/api/search-image?query=Scissor%20Seven%20Chinese%20anime%20poster%20style%2C%20assassin%20character%20with%20scissors%20weapon%2C%20humorous%20and%20action%20mood%2C%20warm%20vibrant%20colors%2C%20clean%20composition%2C%20donghua%20art&width=600&height=840&seq=anime-cover-11&orientation=portrait',
    category: 'chinese',
    rating: 9.4,
    episodes: '全10话',
    status: '已完结',
    description: '伍六七的身世之谜逐渐揭开，暗影刺客组织的往事浮出水面。在搞笑与热血之间，阿七踏上了属于自己的英雄之路。',
    updateInfo: '已完结',
    year: 2024,
    tags: ['搞笑', '热血', '国漫', '动作'],
    views: 1100000,
    likes: 89000,
  },
  {
    id: '12',
    title: '电锯人',
    cover: 'https://readdy.ai/api/search-image?query=Chainsaw%20Man%20anime%20poster%20style%2C%20character%20with%20chainsaw%20arms%20in%20action%2C%20dark%20and%20chaotic%20mood%2C%20gritty%20warm%20red%20and%20dark%20tones%2C%20clean%20composition%2C%20anime%20illustration&width=600&height=840&seq=anime-cover-12&orientation=portrait',
    category: 'japanese',
    rating: 9.2,
    episodes: '全12话',
    status: '已完结',
    description: '贫困少年淀治与恶魔波奇塔融合成为电锯人，加入公安对魔特异课。在残酷的世界中，他追寻着最简单的梦想。',
    updateInfo: '已完结',
    year: 2022,
    tags: ['热血', '暗黑', '战斗', '奇幻'],
    views: 3800000,
    likes: 310000,
  },
];

export const articles = [
  {
    id: '1',
    title: '2025年夏季新番推荐：这十部作品不容错过',
    excerpt: '随着七月新番季的到来，今年的夏季档可谓群星璀璨。从热血战斗到温馨日常，从悬疑推理到异世界冒险，我们为你精心挑选了十部最值得期待的夏季新番。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20summer%20season%20collage%20with%20multiple%20colorful%20character%20silhouettes%2C%20vibrant%20warm%20summer%20vibes%2C%20gradient%20orange%20and%20golden%20sky%20background%2C%20clean%20minimal%20composition%2C%20anime%20art%20style&width=800&height=450&seq=article-cover-01&orientation=landscape',
    date: '2025-07-15',
    author: '追番小助手',
    category: '新番推荐',
    categorySlug: 'recent',
    tags: ['夏季新番', '推荐', '2025'],
    views: 56800,
    content: `
      <h2>炎炎夏日，新番来袭</h2>
      <p>随着七月新番季的到来，今年的夏季档可谓群星璀璨。从热血战斗到温馨日常，从悬疑推理到异世界冒险，我们为你精心挑选了十部最值得期待的夏季新番。无论你是资深二次元还是刚入坑的新朋友，这份推荐清单都值得收藏。</p>
      
      <h3>1. 《咒术回战 第三季》</h3>
      <p>作为近年来最热门的战斗番之一，《咒术回战》第三季的回归无疑是本季最大的看点。剧情将围绕咒术高专与诅咒之王的最终对决展开，制作组MAPPA再次展现了顶级的作画水准。虎杖悠仁与伏黑惠的命运走向牵动着每一位观众的心。</p>
      <p><strong>推荐理由：</strong>顶级的战斗作画、紧凑的剧情节奏、深刻的人物塑造。</p>
      
      <h3>2. 《间谍过家家 第二季》</h3>
      <p>福杰一家的故事仍在继续！本季增加了更多关于劳埃德过去的故事线，同时阿尼亚的校园生活也有了新的展开。温馨与搞笑并存，是今夏最适合全家一起观看的番剧。</p>
      <p><strong>推荐理由：</strong>治愈温馨、笑点密集、制作精良。</p>
      
      <h3>3. 《葬送的芙莉莲》</h3>
      <p>这部作品自播出以来便获得超高口碑，讲述了打倒魔王后精灵魔法使芙莉莲重新踏上旅途的故事。细腻的情感描写和富有哲思的剧情令人动容，是本年度最不容错过的作品之一。</p>
      <p><strong>推荐理由：</strong>顶级叙事、情感细腻、音乐优美。</p>

      <h2>异世界冒险类新番</h2>
      <p>今年夏季的异世界番同样精彩纷呈，多部作品都在传统设定上做出了创新突破。</p>

      <h3>4. 《无职转生 第二季 Part 2》</h3>
      <p>鲁迪乌斯的冒险继续，制作质量依旧保持在极高的水准。本季将展现更多关于魔法学院和迷宫都市的故事线。</p>
      <p><strong>推荐理由：</strong>世界观宏大、角色成长细腻、作画精美。</p>

      <h3>5. 《Re：从零开始的异世界生活 第三季》</h3>
      <p>菜月昴的苦难之旅再度开启！白狐社的制作一如既往地精良，水门都市篇的剧情更加扣人心弦。</p>
      <p><strong>推荐理由：</strong>悬疑烧脑、情感冲击力强、世界观丰富。</p>

      <h2>国漫新番推荐</h2>
      <p>国产动画近年来发展迅猛，本季同样有多部佳作值得关注。</p>

      <h3>6. 《一人之下 第五季》</h3>
      <p>作为国漫标杆，《一人之下》第五季的制作水准再次提升。罗天大醮后的故事更加深入，甲申之乱的真相逐渐揭开。</p>
      <p><strong>推荐理由：</strong>剧情深度足、动作设计精良、文化底蕴深厚。</p>

      <h3>7. 《时光代理人 第二季》</h3>
      <p>来自澜映画的这部原创悬疑番在国内外都获得了极高的评价。穿越时空的设定搭配扣人心弦的剧情，让人欲罢不能。</p>
      <p><strong>推荐理由：</strong>原创剧本、悬疑感强、美术风格独特。</p>

      <h2>总结</h2>
      <p>以上就是天天动漫为你整理的2025年夏季新番推荐。每一部作品都有其独特的魅力，希望你能在这个夏天找到属于自己的最爱。记得每周关注天天动漫，获取最新番剧更新和深度评测！</p>
    `,
  },
  {
    id: '2',
    title: '鬼灭之刃：为什么它是现象级作品的五大理由',
    excerpt: '从漫画到动画，《鬼灭之刃》创造了无数记录。本文将深入分析这部作品成功的核心要素，从剧情、角色、制作到文化影响，全面解读鬼灭之刃的现象级成功。',
    cover: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20success%20analysis%20concept%2C%20Japanese%20traditional%20aesthetic%20with%20sword%20and%20flame%2C%20warm%20amber%20lighting%2C%20clean%20elegant%20composition%2C%20anime%20art%20style&width=800&height=450&seq=article-cover-02&orientation=landscape',
    date: '2025-07-10',
    author: '动漫深度评',
    category: '动漫评测',
    categorySlug: 'japanese',
    tags: ['鬼灭之刃', '深度分析', '日漫'],
    views: 89200,
    content: `
      <h2>现象级的诞生</h2>
      <p>《鬼灭之刃》自连载以来，在日本乃至全球掀起了一股前所未有的热潮。从漫画销量打破《海贼王》的垄断，到剧场版《无限列车篇》打破日本影史票房纪录，这部作品用数据证明了自己的现象级地位。那么，鬼灭之刃究竟做对了什么？</p>

      <h3>理由一：极致的情感共鸣</h3>
      <p>鬼灭之刃最打动人心的地方在于它对"情"的刻画。每一个鬼的背后都有一段令人心碎的故事，他们并非天生邪恶，而是在绝望中选择了错误的道路。炭治郎对敌人的怜悯与同情，让这部作品超越了简单的善恶二元对立。</p>
      <p>从蜘蛛山的累到上弦之三的猗窝座，每一个反派的故事都是一场催人泪下的悲剧。这种对人性深处的挖掘，让观众在痛恨鬼的同时又不禁为之惋惜。</p>

      <h3>理由二：ufotable的顶级制作</h3>
      <p>如果说完美的剧情是鬼灭之刃的骨架，那么ufotable的制作就是它的血肉。浮世绘风格的战斗特效、丝滑流畅的动作场面、细腻入微的情感表达，将这部作品的魅力发挥到了极致。</p>
      <p>特别是第十九话"火之神"，那田蜘蛛山篇的高潮段落被誉为"动画史上的经典时刻"。配乐、声优、作画的三重奏，创造了无与伦比的视听盛宴。</p>

      <h3>理由三：鲜明立体的角色群像</h3>
      <p>炭治郎的温柔善良、祢豆子的可爱坚强、善逸的胆怯中藏着勇敢、伊之助的野性中透着纯真——每一个角色都栩栩如生。九柱更是各自拥有独特的性格与魅力，让人忍不住为每一个角色喝彩。</p>
      <p>角色的成长弧光也极其清晰，从弱小到强大，从迷茫到坚定，每个角色的蜕变都让人感同身受。</p>

      <h3>理由四：简洁纯粹的核心主题</h3>
      <p>"家人"是贯穿鬼灭之刃始终的核心主题。炭治郎为妹妹踏上灭鬼之路，每个柱也有自己守护的信念。这种纯粹而普世的价值观，跨越了文化和国界的限制。</p>
      <p>在复杂的世界中讲述简单的故事，用真挚的情感打动每一位观众——这或许就是鬼灭之刃最大的魅力所在。</p>

      <h3>理由五：时代背景的文化魅力</h3>
      <p>大正时代的浪漫与鬼杀队的传奇相结合，为作品增添了独特的文化魅力。精致的和服设计、传统建筑的美感、日本民间传说的融入，都让这部作品拥有了深厚的文化底蕴。</p>

      <h2>结语</h2>
      <p>鬼灭之刃的成功不是偶然的。优秀的故事内核、顶级的动画制作、深入人心的角色塑造，共同铸就了这部现象级作品。它的意义不仅在于商业成功，更在于让更多人重新认识了动画这门艺术形式的无限可能。</p>
    `,
  },
  {
    id: '3',
    title: '国漫崛起：盘点近年来最值得关注的国产动画',
    excerpt: '从《一人之下》到《时光代理人》，从《伍六七》到《罗小黑战记》，国产动画正在用实力证明自己。让我们一起回顾那些令人惊艳的国漫佳作。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20donghua%20collage%20with%20diverse%20characters%2C%20modern%20Chinese%20aesthetic%2C%20warm%20vibrant%20colors%2C%20clean%20dynamic%20composition%2C%20anime%20art%20style&width=800&height=450&seq=article-cover-03&orientation=landscape',
    date: '2025-07-05',
    author: '国漫观察员',
    category: '国漫专区',
    categorySlug: 'chinese',
    tags: ['国漫', '推荐', '中国动画'],
    views: 65400,
    content: `
      <h2>国漫的黄金时代</h2>
      <p>曾几何时，国产动画被贴上了"低幼"的标签。但近年来，随着一批优秀作品的出现，这种刻板印象正在被彻底打破。从《大圣归来》到《哪吒之魔童降世》，从《一人之下》到《时光代理人》，国漫正在迎来属于自己的黄金时代。</p>

      <h3>《一人之下》：国漫的里程碑</h3>
      <p>如果要选一部最能代表国漫水准的作品，《一人之下》当之无愧。这部作品巧妙地将中国传统文化中的道教思想、武术、异术与现代都市生活融合，创造出了一个充满魅力的"异人世界"。</p>
      <p>张楚岚与冯宝宝的组合既有热血战斗，又有轻松搞笑，更不乏对人性的深刻思考。动画的制作水准也逐年提升，第五季的战斗场面已经可以与国际一流作品比肩。</p>

      <h3>《时光代理人》：国产原创的骄傲</h3>
      <p>作为一部原创作品，《时光代理人》用实力证明了国漫不需要依赖IP改编也能获得成功。穿越时空的设定配合悬疑推理的剧情，每一集都让人欲罢不能。</p>
      <p>作品在海外同样获得了极高的评价，在欧美动漫社区引起了广泛讨论。这不仅仅是一部优秀的国产动画，更是一部能在国际舞台上展现中国动画人实力的作品。</p>

      <h3>《伍六七》：独树一帜的喜剧风格</h3>
      <p>阿七的故事让人捧腹大笑，却又在不经意间触动人心。这部作品独特的幽默感和接地气的表达方式，让它成为了最具辨识度的国漫之一。从鸡大保到梅花十三，每一个配角都让人印象深刻。</p>

      <h3>《罗小黑战记》：治愈系的精品</h3>
      <p>从网络动画到院线电影，《罗小黑战记》用近乎"佛系"的更新速度换来了极高的作品质量。简洁可爱的画风、温馨治愈的故事、精心设计的世界观，让这部作品成为了无数观众心中的白月光。</p>

      <h2>国漫的未来</h2>
      <p>随着资本的注入和人才的成长，国漫正在经历前所未有的高速发展期。从2D到手绘，从3D到三渲二，技术手段日益丰富。更重要的是，我们正在培养出一批有想法、有才华的创作者。</p>
      <p>当然，国漫还有很多路要走——产能的提升、剧本的打磨、产业链的完善，每一步都不会轻松。但看到这一部部优秀的作品不断涌现，我们有理由相信，国漫的未来是光明的。</p>
    `,
  },
  {
    id: '4',
    title: '动漫音乐推荐：那些让人循环播放的经典OST',
    excerpt: '好的动画离不开优秀的配乐。从梶浦由记到泽野弘之，从LiSA到Aimer，我们精选了动漫史上最动人心弦的原声配乐，带你重温那些经典的旋律。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20music%20OST%20concept%20with%20headphones%20and%20musical%20notes%2C%20warm%20golden%20and%20amber%20lighting%2C%20nostalgic%20vibe%2C%20clean%20elegant%20composition%2C%20anime%20aesthetic&width=800&height=450&seq=article-cover-04&orientation=landscape',
    date: '2025-06-28',
    author: '音乐宅',
    category: '动漫文化',
    categorySlug: 'japanese',
    tags: ['OST', '动漫音乐', '推荐'],
    views: 43200,
    content: `
      <h2>音乐，动画的灵魂</h2>
      <p>一部优秀的动画作品，离不开出色的配乐。音乐能够烘托氛围、强化情感、塑造角色，甚至在很多时候，一首歌就能让人瞬间回忆起整部作品。今天，让我们一起回顾那些动漫史上最经典的OST。</p>

      <h3>梶浦由记的音乐魔法</h3>
      <p>提到动漫配乐，梶浦由记是一个绕不开的名字。从《魔法少女小圆》到《Fate/Zero》，从《空之境界》到《刀剑神域》，她的作品总能用独特的世界观音乐将观众带入另一个世界。</p>
      <p>她那标志性的"梶浦语"合唱、复杂的和声编排、富有层次感的编曲，让每一首配乐都如同一首独立的交响诗。推荐：《Sis Puella Magica!》、《the battle is to the strong》。</p>

      <h3>泽野弘之的史诗级配乐</h3>
      <p>泽野弘之的音乐总是充满了史诗感和爆发力。《进击的巨人》中的《Vogel im Käfig》和《YouSeeBIGGIRL/T:T》至今仍让人热血沸腾。他的配乐不仅在动画中完美契合剧情，单独聆听也同样令人震撼。</p>

      <h3>LiSA：燃曲女王</h3>
      <p>从《刀剑神域》的《crossing field》到《鬼灭之刃》的《紅蓮華》和《炎》，LiSA用一首又一首燃曲征服了全球的动漫迷。她那充满力量感的嗓音，总能在最关键的时刻点燃观众的激情。</p>

      <h3>Aimer：温柔的力量</h3>
      <p>如果说LiSA代表的是燃烧的火焰，那么Aimer就是温柔的月光。她用独特的嗓音演绎了无数令人心碎又治愈的歌曲，《Fate/stay night [Heaven's Feel]》的主题曲《花の唄》和《I beg you》都是经典中的经典。</p>

      <h2>国漫配乐的崛起</h2>
      <p>近年来，国产动画的配乐水准也在飞速提升。《一人之下》的多首主题曲和配乐都达到了极高的水准，融合了传统民乐与现代流行元素，既保留了中国特色又不失现代感。</p>
      <p>《时光代理人》的OP《Dive Back In Time》和ED《OverThink》同样深受好评，证明了国产动画音乐完全有能力与国际一流作品同台竞技。</p>

      <h2>结语</h2>
      <p>音乐是时间的艺术，也是情感的艺术。一首好的动漫配乐，能让多年后的我们仍然热泪盈眶。希望这份推荐清单能为你的歌单增添一些新的选择，也希望你能在这些旋律中找到属于自己的感动。</p>
    `,
  },
  {
    id: '5',
    title: '新入坑必看：零基础动漫入门指南',
    excerpt: '想开始看动漫但不知道从何入手？别担心！这份入门指南为你精心挑选了最适合新手的入门番剧，涵盖不同类型和风格，让你快速融入二次元的世界。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20beginner%20guide%20concept%2C%20open%20book%20with%20colorful%20anime%20elements%20floating%2C%20warm%20inviting%20lighting%2C%20clean%20friendly%20composition%2C%20anime%20art%20style&width=800&height=450&seq=article-cover-05&orientation=landscape',
    date: '2025-06-20',
    author: '新手向导',
    category: '动漫指南',
    categorySlug: 'recent',
    tags: ['入门', '新手', '推荐'],
    views: 120000,
    content: `
      <h2>欢迎来到动漫的世界！</h2>
      <p>也许你是因为朋友推荐，也许是被某部热门作品吸引，也许只是单纯好奇——无论如何，欢迎来到动漫这个精彩纷呈的世界！本指南将帮助你迈出第一步，从零开始探索动漫的无限魅力。</p>

      <h3>第一步：选择你的第一部动画</h3>
      <p>作为新入坑的观众，选择一部合适的入门作品至关重要。我们推荐以下标准：</p>
      <ul>
        <li><strong>篇幅适中：</strong>12-25话左右，不会太长也不会太短</li>
        <li><strong>剧情完整：</strong>选择已经完结的季度，避免追番的等待焦虑</li>
        <li><strong>口碑良好：</strong>选择评分高、评价稳定的作品</li>
      </ul>

      <h3>新手推荐清单</h3>
      <p><strong>1. 《鬼灭之刃》（热血战斗）</strong>—— 剧情简单直接、战斗精彩绝伦、情感真挚感人，是最适合新手的入门神作。</p>
      <p><strong>2. 《间谍过家家》（日常喜剧）</strong>—— 轻松愉快的家庭喜剧，笑点密集又不失温馨，适合想要放松心情的你。</p>
      <p><strong>3. 《你的名字。》（动画电影）</strong>—— 不需要追连载，一部电影的时间就能体验完整的故事。新海诚的唯美画风和感人剧情让人沉浸其中。</p>
      <p><strong>4. 《排球少年!!》（运动热血）</strong>—— 即使你不了解排球也能看得热血沸腾，友情与拼搏的主题永不褪色。</p>
      <p><strong>5. 《紫罗兰永恒花园》（治愈唯美）</strong>—— 京都动画的巅峰之作，每一帧都是壁纸级别的精美画面，故事温暖而深沉。</p>

      <h3>第二步：了解追番方式</h3>
      <p>现在观看动漫的方式非常多样。你可以通过各大正版平台（如Bilibili、腾讯视频、爱奇艺动漫等）观看正版授权的中文字幕动画。天天动漫也会持续为你推荐每周更新的最新番剧。</p>

      <h3>第三步：加入社区</h3>
      <p>动漫的魅力不仅在于观看，更在于分享。加入动漫社区（如贴吧、B站评论区、豆瓣小组等），和其他同好交流心得、分享推荐，会让你的追番体验更加丰富。</p>

      <h2>最后的建议</h2>
      <p>每个人都有自己独特的品味，不要因为他人的评价而限制自己的选择。多尝试不同类型的作品，你一定会找到属于自己的最爱。最重要的是——享受这个过程！</p>
    `,
  },
  {
    id: '6',
    title: '一月新番总结：本季度最值得补的番剧排行榜',
    excerpt: '冬季番季已经接近尾声，是时候做一次完整的回顾了。我们整理了本季度口碑最好的十部作品，帮你快速锁定最值得补番的选择。',
    cover: 'https://readdy.ai/api/search-image?query=Winter%20anime%20season%20summary%20concept%2C%20snowy%20atmosphere%20with%20warm%20indoor%20cozy%20vibes%2C%20anime%20characters%20silhouettes%2C%20warm%20amber%20lighting%2C%20clean%20composition&width=800&height=450&seq=article-cover-06&orientation=landscape',
    date: '2025-06-15',
    author: '季度盘点君',
    category: '新番推荐',
    categorySlug: 'recent',
    tags: ['季度总结', '推荐', '榜单'],
    views: 78500,
    content: `
      <h2>冬季番季回顾</h2>
      <p>随着三月尾声的到来，冬季番季也进入了完结倒计时。本季度的作品质量整体较高，多部作品都交出了令人满意的答卷。以下是天天动漫为你整理的本季度最值得补番的作品排行榜。</p>

      <h3>TOP 1：葬送的芙莉莲（续）</h3>
      <p>本季度的绝对王者。延续了前季的超高水准，情感表达更加成熟深邃，画面和音乐都是顶级水准。如果你只看一部冬季番，这是不二之选。</p>

      <h3>TOP 2：咒术回战 第三季</h3>
      <p>MAPPA的制作依然稳定发挥，战斗场面燃到爆炸。剧情进入关键转折点，每一集都让人屏息凝神。动作戏爱好者绝对不能错过。</p>

      <h3>TOP 3：迷宫饭</h3>
      <p>一部将美食与奇幻冒险巧妙结合的作品。独特的世界观设定、精致的料理画面、轻松幽默又不失深度的剧情，让它成为了本季度的最大黑马。</p>

      <h3>TOP 4：药屋少女的呢喃</h3>
      <p>宫廷悬疑与医药知识的巧妙结合，女主猫猫的聪明才智让人看得过瘾。精美的作画和考究的时代背景还原度令人赞叹。</p>

      <h3>TOP 5：我心里危险的东西 第二季</h3>
      <p>最甜校园恋爱番的续作，男女主角的关系在本季有了实质性进展。细腻的情感描写和恰到好处的喜剧节奏，让人看完心头暖暖的。</p>

      <h2>补番建议</h2>
      <p>如果你时间有限，优先推荐TOP 3的作品。如果你喜欢不同类型的作品，可以根据自己的偏好选择。最重要的是——享受追番的过程！</p>
    `,
  },
];

export const aboutData = {
  brandIntro: {
    title: '关于天天动漫',
    subtitle: '让每一天都与动漫相伴',
    description: '天天动漫成立于2020年，是国内领先的动漫在线观看与资讯平台。我们致力于为中国动漫爱好者提供最全面、最及时、最高清的动漫资源，涵盖热门新番、经典老番、国漫日漫、剧场版等丰富的动漫内容。',
    mission: '我们的使命是让每一位动漫爱好者都能在天天动漫找到属于自己的快乐。从番剧推荐到深度评测，从最新资讯到社区交流，天天动漫希望成为你追番路上最可靠的伙伴。',
    vision: '未来，天天动漫将继续拓展内容版图，为动漫产业的发展贡献力量。',
  },
  reputation: {
    title: '平台口碑',
    items: [
      { label: '累计用户', value: '500万+', icon: 'ri-user-heart-line' },
      { label: '收录番剧', value: '3000+', icon: 'ri-movie-line' },
      { label: '日均访问', value: '120万+', icon: 'ri-eye-line' },
      { label: '用户好评率', value: '98.5%', icon: 'ri-thumb-up-line' },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们的团队将尽快回复您的消息。',
    email: 'contact@tiantiananime.com',
    phone: '400-888-6666',
    address: '北京市朝阳区动漫产业园A座15层',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};

export const siteInfo = {
  name: '天天动漫',
  tagline: '每天追番看动漫，海量资源免费在线',
  description: '天天动漫是你每天追番的首选平台，汇聚海量动漫资源，涵盖热门新番、经典老番、国漫日漫，高清免费在线观看，随时随地畅享动漫世界，让每一天都与动漫相伴。',
  keywords: '天天动漫,天天动漫在线观看,天天动漫免费追番,天天动漫最新番剧,动漫在线平台,热门新番推荐,高清动漫资源',
  url: 'https://www.tiantiananime.com',
  logo: 'https://readdy.ai/api/search-image?query=Anime%20website%20logo%20design%2C%20simple%20minimal%20cute%20anime%20style%20icon%2C%20warm%20orange%20and%20golden%20gradient%2C%20clean%20white%20background%2C%20flat%20design%2C%20no%20text&width=200&height=200&seq=site-logo&orientation=squarish',
};